module.exports = __webpack_public_path__ + "static/media/bank.2875f35b.png";